<template>
  <svg
    width="21px"
    height="22px"
    viewBox="0 0 21 22"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="Home-1"
        transform="translate(-1721.000000, -98.000000)"
        stroke="#000000"
        stroke-width="2"
      >
        <g id="Nav" transform="translate(40.000000, 98.000000)">
          <g id="Group-5" transform="translate(1682.000000, 0.000000)">
            <g
              id="explore"
              transform="translate(9.444444, 11.000000) scale(-1, 1) translate(-9.444444, -11.000000) translate(-0.000000, 1.000000)"
            >
              <path
                d="M11.6666667,0 C15.655303,0 18.8888889,3.23358586 18.8888889,7.22222222 C18.8888889,11.2108586 15.655303,14.4444444 11.6666667,14.4444444 C7.6780303,14.4444444 4.44444444,11.2108586 4.44444444,7.22222222 C4.44444444,3.23358586 7.6780303,0 11.6666667,0 Z"
                id="Stroke-1"
              ></path>
              <line
                x1="0.555555556"
                y1="20"
                x2="7.22222222"
                y2="12.2222222"
                id="Stroke-3"
              ></line>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "icon-search",
};
</script>

<style scoped lang="scss">
path {
  transition: stroke 0.3s ease;
}
.theme-dark svg {
  path,
  line {
    stroke: #ffffff;
  }
  &:hover {
    path {
      stroke: #666;
    }
  }
}

.theme-light svg {
  path {
    stroke: #000000;
  }
  &:hover {
    path {
      stroke: #666;
    }
  }
}
</style>
